export default __webpack_public_path__ + "static/media/Activate_UserGuide.31982063.pdf";